export class AccountIdCondition {
    'operator';
    'accountIds';
    static discriminator = undefined;
    static attributeTypeMap = [
        {
            "name": "operator",
            "baseName": "operator",
            "type": "ScalarOperators",
            "format": ""
        },
        {
            "name": "accountIds",
            "baseName": "accountIds",
            "type": "Array<string>",
            "format": ""
        }
    ];
    static getAttributeTypeMap() {
        return AccountIdCondition.attributeTypeMap;
    }
    constructor() {
    }
}
